import type { FC } from 'react';
import { Typography } from '@mui/material';
import SomethingWentWrongImage from '../images/SomethingWentWrong.svg';
import { Button } from '../Button';
import { useTranslation } from 'react-i18next';
import { ErrorContainer } from './ErrorContainer';

export const AppUpdated: FC = () => {
  const { t } = useTranslation();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <ErrorContainer>
      <img
        alt={t('errors.app-updated')}
        src={SomethingWentWrongImage}
        style={{ marginBottom: 44 }}
      />
      <Typography
        variant="inherit"
        sx={{
          fontWeight: '700',
          mb: 3,
        }}
      >
        {t('errors.app-updated')}
      </Typography>
      <Button
        sx={{ mb: 3 }}
        variant="contained"
        autoFocus
        onClick={handleRefresh}
      >
        {t('errors.refresh-page')}
      </Button>
    </ErrorContainer>
  );
};
